import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Icon } from 'shared/components';

import theme from './DropdownMenu.scss';

class DropdownMenu extends Component {

  static propTypes = {
    className: PropTypes.string,
    menuItems: PropTypes.arrayOf(PropTypes.shape({
      itemName: PropTypes.string.isRequired,
      iconName: PropTypes.string,
      onClick: PropTypes.func,
    }).isRequired),
    topRight: PropTypes.bool,
    topLeft: PropTypes.bool,
    bottomRight: PropTypes.bool,
    bottomLeft: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    menuItems: [],
    topRight: false,
    topLeft: false,
    bottomRight: false,
    bottomLeft: false,
  };

  state = {
    menuVisible: false,
  };

  componentDidMount() {
    document.addEventListener('click', this.hideMenu, true);
  }

  comonentWillUnmount() {
    document.removeEventListener('click', this.hideMenu, true);
  }

  showMenu = () => {
    this.setState({
      menuVisible: true,
    });
  };

  hideMenu = () => {
    this.setState({
      menuVisible: false,
    });
  };

  render() {
    const { menuItems, topRight, topLeft, bottomRight, bottomLeft } = this.props;

    return (
      <div className={ theme.root }>
        <Icon
          className={ theme.dotsMenu }
          name="dots-menu"
          onClick={ this.showMenu }
        />

        <div className={ classnames(theme.menu, {
          [theme.topRight]: topRight,
          [theme.topLeft]: topLeft,
          [theme.bottomRight]: bottomRight,
          [theme.bottomLeft]: bottomLeft,
          [theme.opened]: this.state.menuVisible,
        }) }
        >
          { menuItems.map(({ itemName, iconName, onClick }) => (
            <div
              className={ classnames(theme.item, {
                [theme.oneItem]: menuItems.length === 1,
              }) }
              key={ `item-${ itemName }` }
              onClick={ onClick }
            >
              <Icon
                className={ classnames({
                  [theme.itemIcon]: iconName,
                }) }
                name={ iconName }
              />
              { itemName }
            </div>
          )) }
        </div>
      </div>
    );
  }
}

export default DropdownMenu;
